<!--修改孩子等级-->
<template>
  <div class="root-container">
    <el-form   label-width="150px">
      <el-form-item label="会员姓名:" >
        <el-input style="width: 300px;" readonly=true v-model="child.name"></el-input>
      </el-form-item>
      <el-form-item label="设置新等级:">
        <el-select v-model="level" placeholder="请选择" style="width: 300px;">
          <el-option
            v-for="item in levelOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        
      </el-form-item>

      <el-form-item  v-for="(subType,index) in subCardTypes" :key="subType.id" :label="subType.type">
        <el-select v-model="selectSubTypes[index]" placeholder="请选择" style="width: 300px;">
          <el-option
            v-for="item in levelOption"
            :key="item.value"
            :label="item.label"
            :value="subType.id +'-'+item.value">
          </el-option>
        </el-select>
       
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button style="background-color: #F14B39 ;color: white;" @click="onClickChange()">确认修改</el-button>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>


  import timeUtils from "../../utils/timeUtils";
  import globaldata from "../../utils/globaldata";
  import commonUtils from "../../utils/commonUtils";
  import enumsUtil, {EAllLevelOption} from "../../utils/enumsUtil";
  import messageUtils from "../../utils/messageUtils";
  import {changeChildLevel, selectChild} from "../../api/userChild";
  import {getCardSubTypeList,} from "../../api/StoreLessonCard";
  export default {
    name: 'ChangeChildLevel',
    props: {
      childId:Number
    },
    data() {
      return {
        child:"",

        levelOption:EAllLevelOption(),
        level:0,
        subCardTypes:[],
        selectSubTypes:[],
      }
    },
    created(){
      this.initData();

    },
    filters:{
      formatTime(time) {
        if(time==null||time===''){
          return 'N/A';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },



    },
    methods: {

      initData(){
        this.child = "";
        let param = {
          id:this.childId,
        }
        selectChild(param).then(response =>
        {
          
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.child = data;
          this.level = data.level;
          let CardSubTypeParam = {
            storeFrontId:globaldata.getAdminStore().storeFrontId,
            storeLessonCardTemplateId:1
          }
          getCardSubTypeList(CardSubTypeParam).then(response =>
            {
              let data = response.data;
              if (commonUtils.isObjectNull(data)){
                return;
              }
              for (let i = 0;i< data.length;++i){
                let option = {
                  id:data[i].id,
                  type:data[i].name,
                }
                let select = option.id+'-0'
                for(let j = 0;j< this.child.subTypeJson.length;++j){
                  if(this.child.subTypeJson[j].subTypeId === option.id){
                    select = this.child.subTypeJson[j].subTypeId+'-'+this.child.subTypeJson[j].subTypeLevel
                  }
                }
                this.subCardTypes.push(option);
                this.selectSubTypes.push(select);
              }

            })
          
        })
        
      },



      onClickChange(){
        if (commonUtils.isStringNull(this.childId)){
          messageUtils.errorMsg("未选择会员!!!");
          return;
        }
        let param = {
          id:this.child.id,
          level:this.level,
          selectSubTypes:this.selectSubTypes
        }
        changeChildLevel(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          messageUtils.successMsg(this,response.message);
          this.$emit('onChangeSuccess');
        })

      },

    },


  }
</script>






// WEBPACK FOOTER //
// src/views/components/ChangeChildLevel.vue